{{#> elements/_dt}}
  {{> elements/_label }}
{{/elements/_dt}}
<dd>
  <textarea
    name="{{prefix}}[patient_note][]"
    id="{{id}}"
    {{#if required}}required{{/if}}
    {{#if disabled}}disabled{{/if}}
    {{#if placeholder }} placeholder="{{placeholder}}" {{/if}}
  >{{value}}</textarea>
</dd>
